<template>
  <vuestic-navbar>
    <header-selector slot="selector" :isOpen.sync="valueProxy"/>
    <span slot="logo" class="manage-logo">
      <!-- <vuestic-icon-vuestic/> -->{{VUE_APP_NAME}}
    </span>
    <span slot="center">
      <!-- {{$t('navbar.messageUs')}}&nbsp;<a href="mailto:hello@epicmax.co">hello@epicmax.co</a> -->
    </span>

    <!-- <message-dropdown class="col nav-item"/> -->
    <!-- <notification-dropdown class="col nav-item"/> -->
    <!-- 注释了切换多语言 -->
    <language-dropdown class="col nav-item"/>
    <profile-dropdown class="col nav-item nav-profile">
      <img :src="headerIcon"/>
      <div class="nav-profile-info">
        <span>
          {{merchant_name}}
        </span>
        <br />
        <span>
          {{user_name}}
        </span>
        <br />
        <span>
          {{merchant_no}}
        </span>
      </div>
    </profile-dropdown>
  </vuestic-navbar>

</template>

<script>
import VuesticIconVuestic from '../../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'
import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
import HeaderSelector from './components/HeaderSelector'
import LanguageDropdown from './components/dropdowns/LanguageDropdown'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
// import NotificationDropdown from './components/dropdowns/NotificationDropdown'
// import MessageDropdown from './components/dropdowns/MessageDropdown'

export default {
  name: 'app-navbar',
  data() {
    return {
      headerIcon: require('@/assets/images/8.png'),
      user_name: '',
      merchant_name: '',
      merchant_no: '',
      VUE_APP_NAME: process.env.VUE_APP_NAME
    }
  },
  components: {
    VuesticIconVuestic,
    VuesticNavbar,
    HeaderSelector,
    // MessageDropdown,
    // NotificationDropdown,
    LanguageDropdown,
    ProfileDropdown,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    valueProxy: {
      get () {
        return this.isOpen
      },
      set (opened) {
        this.$emit('toggle-menu', opened)
      },
    },
  },
  mounted () {
    this.initUserData()
  },
  methods: {
    initUserData () {
      let user = JSON.parse(localStorage.getItem('userInfo')).info.data
      let merchantName = localStorage.getItem("merchantName")
      let merchantNo = localStorage.getItem("merchantNo")
      this.user_name = user.username
      this.merchant_name = merchantName
      this.merchant_no = merchantNo
    }
  }
}
</script>
<style lang="scss">
  .manage-logo{
    font-weight: 600;
    letter-spacing: 4px;
    font-size: 20px;
    line-height: 13px;
    font-family:Arial, Helvetica, sans-serif
  }
  @media only screen and (max-width: 750px) {
    .manage-logo {
      margin-left: -29px;
      letter-spacing: 0;
    }
  }
  .nav-profile {
    justify-content: end !important;
    .profile-dropdown__avatar-container {
      display: flex;
      flex-direction: row;
      overflow: unset;
      background-color: unset;
      border-radius: unset;
      border: unset;
      width: auto;
      img {
        border-radius: 50%;
        margin-right: 10px;
        width: auto;
      }
      .nav-profile-info {
        line-height: 1.4;
        font-size: 14px;
        margin-top: -4px;
        span {
          color: #FFFFFF;
          white-space: nowrap;
        }
      }
    }
  }

</style>
